var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 1.45594C37.1 1.45594 28.53 12.1159 20.49 12.1159H4.66503C4.24537 12.1159 3.84288 12.2826 3.54603 12.5792C3.24919 12.8759 3.0823 13.2783 3.08203 13.6979V23.1979C3.08203 23.6178 3.24881 24.0204 3.54568 24.3173C3.84255 24.6142 4.24519 24.7809 4.66503 24.7809H20.49C28.531 24.7809 37.1 35.4809 37.1 35.4809C37.3016 35.6542 37.5472 35.7685 37.8096 35.8112C38.072 35.8538 38.3411 35.8232 38.5872 35.7227C38.8334 35.6222 39.047 35.4557 39.2045 35.2415C39.362 35.0273 39.4574 34.7738 39.48 34.5089V2.42194C39.4708 2.15038 39.3832 1.88729 39.2278 1.66445C39.0723 1.44161 38.8556 1.26855 38.6039 1.16618C38.3522 1.06381 38.0763 1.03651 37.8094 1.08757C37.5425 1.13864 37.2962 1.26589 37.1 1.45394V1.45594Z",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.083 21.6112C3.083 21.6112 1.5 21.0173 1.5 18.4463C1.5 15.8753 3.083 15.2812 3.083 15.2812",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0625 20.6215C41.5225 20.4727 41.9235 20.182 42.208 19.791C42.4924 19.4001 42.6457 18.929 42.6457 18.4455C42.6457 17.962 42.4924 17.491 42.208 17.1C41.9235 16.7091 41.5225 16.4183 41.0625 16.2695",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0723 12.1162V24.7762",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83008 12.1162V24.7762",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9941 24.7764V41.3934C10.9941 41.4974 11.0146 41.6004 11.0544 41.6965C11.0942 41.7925 11.1526 41.8799 11.2261 41.9534C11.2997 42.0269 11.387 42.0853 11.4831 42.1251C11.5791 42.1649 11.6821 42.1854 11.7861 42.1854H17.0291C17.2771 42.1853 17.5215 42.1271 17.7428 42.0153C17.9641 41.9035 18.156 41.7413 18.3031 41.5417C18.4502 41.3421 18.5484 41.1108 18.5897 40.8664C18.6311 40.6219 18.6144 40.3712 18.5411 40.1344C17.7111 37.4744 15.7411 34.4764 15.7411 29.5234H17.3241C17.744 29.5234 18.1466 29.3566 18.4435 29.0597C18.7404 28.7628 18.9071 28.3602 18.9071 27.9404V26.3594C18.9071 25.9395 18.7404 25.5369 18.4435 25.24C18.1466 24.9431 17.744 24.7764 17.3241 24.7764H15.7421",
    stroke: "#000FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneSelected);
export default __webpack_public_path__ + "static/media/megaphone_selected.9a29c1181491baf83da697dcbdac8c9b.svg";
export { ForwardRef as ReactComponent };